import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * PageSEO Component - Manages meta tags and structured data for each page
 * @param {string} title - Page title
 * @param {string} description - Meta description
 * @param {string} keywords - SEO keywords
 * @param {string} url - Canonical URL
 * @param {string} image - OG image URL
 * @param {string} type - Schema.org type (default: website)
 * @param {object} structuredData - Additional JSON-LD structured data
 */
const PageSEO = ({
  title,
  description,
  keywords,
  url = "https://yuvasree.online",
  image = "https://yuvasree.online/og-image.png",
  type = "website",
  structuredData = null
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Yuvasree Padmanabhan" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default PageSEO;
